import { Grid, Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Logo } from 'ui-component';

interface LogoBarProps {
    open: boolean;
    projectLogo: string;
    projectTitle: string;
    address?: string;
}

const LogoBar = (props: LogoBarProps) => {
    const { open, projectLogo, projectTitle, address } = props;
    const theme = useTheme();
    const lgUp = useMediaQuery(theme.breakpoints.up('lg'));

    return (
        <Box
            sx={{
                height: open ? { xs: 92, sm: 95 } : 0,
                opacity: open ? 1 : 0,
                alignItems: 'center',
                justifyContent: 'flex-start',
                display: 'flex',
                position: 'relative',
                transition: 'height 0.4s ease, opacity 0.4s ease',
                pl: { xs: '86px', sm: '112px', md: '24vw', lg: '12vw' },
                pr: { xs: 1.5, sm: 2 }
            }}
        >
            <Box sx={{ position: 'absolute', top: { xs: 12, md: '2vh' }, left: { xs: 16, sm: 24, md: '6vw' } }}>
                <Logo
                    logo={projectLogo}
                    dimensions={{ width: lgUp ? 76 : 58, height: lgUp ? 76 : 58 }}
                    styles={{ backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
                />
            </Box>
            <Grid container xs={12} sx={{ minWidth: 0 }}>
                <Grid item xs={12}>
                    <Typography
                        variant="h4"
                        fontSize={{ xs: '0.95rem', sm: '1.05rem', md: 'large', lg: 'x-large' }}
                        lineHeight={{ xs: 1.2, sm: 1.25 }}
                        fontWeight={400}
                        sx={{ flexGrow: 1, overflowWrap: 'break-word' }}
                    >
                        {projectTitle}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        variant="subtitle1"
                        component="div"
                        fontSize={{ xs: '0.82rem', sm: '0.9rem', md: 'medium' }}
                        lineHeight={{ xs: 1.35, sm: 1.4 }}
                        fontWeight={400}
                        sx={{ flexGrow: 1, overflowWrap: 'break-word' }}
                    >
                        {address}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LogoBar;
